import axios from 'axios';
import { ACTION_LOGOUT } from '../Redux/Action/AuthAction';
import { handleResponse } from './HelperService';

const logoutUser = () => dispatch => {
    dispatch({ type: ACTION_LOGOUT, isLoggedIn: false });
}

const loginUser = (payload, onSuccess, onError) => {
    //const payload = { username: 'muhamad.nur@modena.com', password: 'P@ssw0rd'};
    const response = axios.post("v1/login", payload);
    return handleResponse(response, onSuccess, onError);
}

const getUserAll = (params, onSuccess, onError) => {
    const response = axios.get('v1/user', { params });
    return handleResponse(response, onSuccess, onError);
};

const getUserById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/user/get/${id}`);
    return handleResponse(response, onSuccess, onError);
};

const createUser = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/user/create`, payload);
    return handleResponse(response, onSuccess, onError);
};

const updateUser = (username, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/user/update/${username}`, payload);
    return handleResponse(response, onSuccess, onError);
};

const deleteUser = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/user/delete/${id}`);
    return handleResponse(response, onSuccess, onError);
};

const getMHCDealers = (params, onSuccess, onError) => {
    const response = axios.get('v2/mhc-dealer/dealers', { params });
    return handleResponse(response, onSuccess, onError);
};

const getRoles = (params, onSuccess, onError) => {
    const response = axios.get('v1/roles', { params });
    return handleResponse(response, onSuccess, onError);
};

const getUsersSAP = (params, onSuccess, onError) => {
    const response = axios.get('v2/users-sap', { params });
    return handleResponse(response, onSuccess, onError);
};

const getUsersMI = (params, onSuccess, onError) => {
    const response = axios.get('v2/users-misap', { params });
    return handleResponse(response, onSuccess, onError);
};

const getRoleById = (id, onSuccess, onError) => {
    const response = axios.get('v1/roles/' + id);
    return handleResponse(response, onSuccess, onError);
};

const createRole = (payload, onSuccess, onError) => {
    const response = axios.post('v1/roles', payload);
    return handleResponse(response, onSuccess, onError);
};

const updateRole = (id, payload, onSuccess, onError) => {
    const response = axios.put('v1/roles/' + id, payload);
    return handleResponse(response, onSuccess, onError);
};

const deleteRole = (id, onSuccess, onError) => {
    const response = axios.delete('v1/roles/' + id);
    return handleResponse(response, onSuccess, onError);
};

const getUserBranch = (params, onSuccess, onError) => {
    const response = axios.get('v1/branch', { params });
    return handleResponse(response, onSuccess, onError);
};

const getUserV2 = (params, onSuccess, onError) => {
    const response = axios.get('v2/users', { params });
    return handleResponse(response, onSuccess, onError);
};

const getUserByBranch = (branch_id, onSuccess, onError) => {
    const response = axios.get(`v2/users-mhcowners/${branch_id}`);
    return handleResponse(response, onSuccess, onError);
};

const getUserByIdV2 = (id, onSuccess, onError) => {
    const response = axios.get('v2/users/' + id);
    return handleResponse(response, onSuccess, onError);
};

const getUserByUserIdV2 = (id, onSuccess, onError) => {
    const response = axios.get('v2/users/userid/' + id);
    return handleResponse(response, onSuccess, onError);
};

const createUserV2 = (payload, onSuccess, onError) => {
    const response = axios.post('v2/users', payload);
    return handleResponse(response, onSuccess, onError);
};

const updateUserV2 = (id, payload, onSuccess, onError) => {
    const response = axios.put('v2/users/' + id, payload);
    return handleResponse(response, onSuccess, onError);
};

const resetPassword = (payload, onSuccess, onError) => {
    const response = axios.post('v1/user/password/reset', payload);
    return handleResponse(response, onSuccess, onError);
};

const changePassword = (payload, onSuccess, onError) => {
    const response = axios.post('v1/user/password/change', payload);
    return handleResponse(response, onSuccess, onError);
};

export {
    getMHCDealers,
    changePassword,
    resetPassword,
    logoutUser,
    loginUser,
    getUserAll,
    getUserById,
    createUser,
    updateUser,
    deleteUser,
    getRoles,
    getRoleById,
    createRole,
    updateRole,
    deleteRole,
    getUserV2,
    getUserBranch,
    createUserV2,
    updateUserV2,
    getUserByIdV2,
    getUserByUserIdV2,
    getUsersMI,
    getUsersSAP,
    getUserByBranch
};